export * as locations from '@wix/auto_sdk_business-tools_locations/meta';
export * as siteProperties from '@wix/auto_sdk_business-tools_site-properties/meta';
